var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSaveBookings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 88,
    viewBox: "0 0 109 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.263 5.249c-7.017 6.998-7.017 18.345 0 25.344 7.018 6.999 18.395 6.999 25.413 0 7.017-6.999 7.017-18.346 0-25.344A17.938 17.938 0 0 0 17.969 0C13.371 0 8.772 1.75 5.263 5.249",
    id: "hhynxvu91a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#E0E0E0",
    width: 95.204,
    height: 88,
    rx: 5.789
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F7",
    cx: 11.03,
    cy: 11,
    rx: 6.386,
    ry: 6.368
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F7F7F7",
    x: 22.059,
    y: 6.947,
    width: 67.339,
    height: 9.263,
    rx: 4.632
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7F7F7",
    strokeWidth: 1.158,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.064 22.579H91.14"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.644 30.105)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F7F7F7",
    x: 45.28,
    width: 39.475,
    height: 23.158,
    rx: 4.632
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F7F7F7",
    width: 39.475,
    height: 23.158,
    rx: 4.632
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 13.895,
    fontWeight: "bold",
    fill: "#40AE29"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 50.336,
    y: 16.474
  }, "Save"))), /*#__PURE__*/React.createElement("rect", {
    fill: "#F7F7F7",
    x: 4.644,
    y: 57.895,
    width: 84.754,
    height: 23.158,
    rx: 4.632
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.38 79.742a5.54 5.54 0 0 1-7.819 0L87.833 68.044a5.503 5.503 0 0 1 0-7.798 5.54 5.54 0 0 1 7.819 0l11.729 11.697a5.504 5.504 0 0 1 0 7.799",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.17 63.574a2.77 2.77 0 0 1-3.91 0l-4.72-4.706a2.752 2.752 0 0 1 0-3.9 2.77 2.77 0 0 1 3.91 0l4.72 4.707a2.752 2.752 0 0 1 0 3.9",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.15 53.89c-7.017 6.999-18.395 6.999-25.412 0-7.018-6.999-7.018-18.346 0-25.344 7.017-6.999 18.395-6.999 25.412 0 7.018 6.998 7.018 18.345 0 25.344m2.932-28.269c-8.637-8.613-22.64-8.613-31.277 0-8.636 8.614-8.636 22.58 0 31.193 8.637 8.614 22.64 8.614 31.277 0 8.637-8.613 8.637-22.579 0-31.193",
    fill: "#C4C4C4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveBookings);
export default __webpack_public_path__ + "static/media/icon-save-bookings.528381947e0742210af36e72fc81e852.svg";
export { ForwardRef as ReactComponent };